import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tabs, Tab, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import CreateAgent from './CreateAgent';
import Agentmap from './Agentmap';

// Dummy components for demonstration
const AgentInfo = () => <Box p={2}>Agent Info Content</Box>;
const AgentHistory = () => <Box p={2}>Agent History Content</Box>;

const Agent = ({ open, onClose,onConfirm  }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Dialog open={open} onClose={onClose} minWidth="md" maxWidth="md" fullWidth>
    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Agent 
        <Button onClick={onClose} sx={{ minWidth: 0 }} color="inherit">
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent>
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
         sx={{ mb: 2, width: "100%" }}
          TabIndicatorProps={{ sx: { height: 3 } }}
        >
         <Tab label="Agent Details" sx={{ width: "50%" }} />
          <Tab label="Add Agent" sx={{ width: "50%" }} />
        </Tabs>
       {tabIndex === 0 && <Agentmap onConfirm={onConfirm} onClose={onClose} />}
        {tabIndex === 1 && <CreateAgent />}
      </DialogContent>
     
    </Dialog>
  );
};

export default Agent;